import { render } from "./CmmJxGoodsDetails.vue?vue&type=template&id=7c0214bf&scoped=true"
import script from "./CmmJxGoodsDetails.vue?vue&type=script&lang=js"
export * from "./CmmJxGoodsDetails.vue?vue&type=script&lang=js"

import "./CmmJxGoodsDetails.vue?vue&type=style&index=0&id=7c0214bf&scoped=true&lang=css"

import exportComponent from "C:\\chuning\\cn-page\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0214bf"]])

export default __exports__